import responsiveConfig from './responsiveConfig'

export default {
    ...responsiveConfig,
    extensionsList: responsiveConfig.extensionsList.concat(['views']),
    continuousSave: false,
    initialSeed: 1000
}
